export const data5_6_2 = [{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: '',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
},{
    top20_account: 'Sub-Total 小计',//名称

    cm_thisyear_covers:0,
    cm_thisyear_ac:0,
    cm_thisyear_rev:0,

    cm_lastyear_covers:0,
    cm_lastyear_ac:0,
    cm_lastyear_rev:0,

    cm_comparison_covers:0,
    cm_covers_percent:0,
    cm_comparison_ac:0,
    cm_ac_percent:0,
    cm_comparison_rev:0,
    cm_rev_percent:0,

    ytd_thisyear_covers:0,
    ytd_thisyear_ac:0,
    ytd_thisyear_rev:0,

    ytd_lastyear_covers:0,
    ytd_lastyear_ac:0,
    ytd_lastyear_rev:0,

    ytd_comparison_covers:0,
    ytd_covers_percent:0,
    ytd_comparison_ac:0,
    ytd_ac_percent:0,
    ytd_comparison_rev:0,
    ytd_rev_percent:0,
}];


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-6/5-6-2/data.js